import { 
  SET_TICKET_ID, 
  REMOVE_TICKET_ID,
  PAID_TICKET_ID,
  CHECK_TICKET_STATUS,
  SET_TICKET_PRICE
} from "../actions/ticket";

export default function ticket(state = {
  ticketId: null,
  ticketIdLastUpdated: null,
  paidTicketId: null,
  revenue: null,
  delivery: null,
  gst: null,
  items: null
}, action) {
  switch (action.type) {
    case REMOVE_TICKET_ID:
      return {
        ...state,
        ticketId: null,
      };
    case SET_TICKET_ID:
      return {
        ...state,
        ticketId: action.payload.item,
        ticketIdLastUpdated: action.payload.lastUpdated,
      };
    case SET_TICKET_PRICE:
      return {
        ...state,
        revenue: action.payload.revenue,
        delivery: action.payload.delivery,
        gst: action.payload.gst,
        items: action.payload.items
      }
    case PAID_TICKET_ID:
      return {
        ...state,
        paidTicketId: state.ticketId,
      };
    case CHECK_TICKET_STATUS:

      let diff = Date.now() - state.ticketIdLastUpdated

      if(state.ticketId && diff > 86400000){
        return {
          ...state,
          ticketId: null,
        }
      } else {
        return state
      }
    default:
      return state;
  }
}